<template>
  <div>
    <v-dialog
      v-model="sendDialog"
      max-width="712"
      content-class="position-relative"
    >
      <div
        v-if="loading || isLoading"
        class="position-absolute start-0 top-0 fill-height fill-width d-flex justify-center align-center"
        :class="{ 'loading-candidate': isLoading }"
      >
        <v-progress-circular
          :size="72"
          :width="6"
          color="primary"
          indeterminate
          class="ma-auto"
        ></v-progress-circular>
      </div>
      <template v-slot:activator="{ on, attrs }">
        <Button variant="approve" :disabled="disabled" v-bind="attrs" v-on="on">
          <div
            class="tw-flex tw-gap-3 tw-items-center tw-justify-center tw-text-base tw-min-w-[210px]"
          >
            <div>
              <img :src="LikeIcon" />
            </div>
            <div>Send for Review</div>
          </div>
        </Button>
      </template>
      <v-card>
        <v-card-title
          class="email-popup-title d-flex justify-content-between align-items-center"
        >
          <span> Send candidate to hiring manager </span>
          <span class="close-btn" @click="sendDialog = false"
            ><v-icon size="22" right color="#6B7280"> mdi-close </v-icon></span
          >
        </v-card-title>
        <v-form ref="form1" v-model="formValid">
          <v-simple-table class="email-header">
            <template>
              <tbody>
                <tr>
                  <td>To:</td>
                  <td>
                    <v-text-field
                      v-model="hmFullName"
                      hide-details="auto"
                      :rules="emailRules"
                      class="mail-collaborators"
                      readonly
                    ></v-text-field>
                  </td>
                </tr>
                <tr>
                  <td>CC:</td>
                  <td>
                    <v-combobox
                      v-model="ccAddresses"
                      :items="availableCCAddress"
                      class="mail-collaborators flex-grow-0"
                      :multiple="true"
                      placeholder="Add Team Member..."
                      :menu-props="dropdownSetting"
                    >
                    </v-combobox>
                  </td>
                </tr>
                <tr>
                  <td>Sub:</td>
                  <td>
                    {{ warmLeadsTemplate.email_subject }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-form>
        <div class="email-body-container">
          <div
            id="emailTemplate"
            class="email-body"
            contenteditable="true"
            @input="onChange"
            v-html="warmLeadsTemplate.email_body"
          ></div>
        </div>
        <v-card-actions class="send-btn">
          <v-btn color="primary" :loading="loading" @click="onSubmit">
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" timeout="2000" top>
        {{ snackbarMessage }}
      </v-snackbar>
    </v-dialog>
    <v-dialog v-model="isSuccessSending" width="444">
      <v-card class="success-popup">
        <v-card-text class="pt-4 success-title">
          <v-icon size="22" right color="#4CAF50">
            mdi-checkbox-marked-circle
          </v-icon>
          <span>Success: Email Sent!</span>
        </v-card-text>
        <v-card-text class="mt-0">
          {{ this.hmFullName }} has been notified to review this candidate
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Config from '@/js/config';
import { post } from '@/js/api/sourcer';
import { emailRules } from '@/utils';
import Button from '@/components/v3/base/Button';
import LikeIcon from '@/assets/icons/thumbs-up.svg';

export default {
  name: 'SendToReview',
  components: {
    Button,
  },

  props: {
    tab: {
      type: String,
      default: 'UNDER_REVIEW',
    },

    candidate: {
      type: Object,
      default: () => {},
    },

    projectId: {
      type: String,
    },

    disabled: Boolean,
  },

  data() {
    return {
      formValid: false,
      sendDialog: false,
      ccAddresses: [],
      isSuccessSending: false,
      snackbar: false,
      snackbarMessage: '',
      loading: false,
      isEdited: false,
      emailBody: '',
      dropdownSetting: {
        closeOnContentClick: true,
      },

      hmFullName: '',
      emailRules,
      LikeIcon,
    };
  },

  computed: {
    candidateId() {
      return this.candidate._id;
    },

    warmLeadsTemplate() {
      return this.$store.getters['projects/candidates/getWarmLeadsTemplate'];
    },

    projectSetting() {
      if (!this.projectId) {
        return {};
      }

      return this.$store.getters['projects/settings/getSettingsByProjectId'](
        this.projectId
      );
    },

    collaborators() {
      return this.projectSetting.collaborators || [];
    },

    availableCCAddress() {
      const result = this.warmLeadsTemplate.hm_cc_emails
        ? [...this.warmLeadsTemplate.hm_cc_emails]
        : [];
      this.collaborators.forEach((element) => {
        if (element.email !== this.hmFullName) {
          result.push(element.email);
        }
      });
      return result;
    },

    isLoading() {
      return this.$store.getters['projects/candidates/getIsLoading'];
    },

    isV2() {
      return this.$store.getters['user/getIsUserV2'];
    },
  },

  watch: {
    sendDialog() {
      if (this.sendDialog) this.getWarmLeadsTemplate();
      this.hmFullName = '';
      this.ccAddresses = [];
    },

    warmLeadsTemplate() {
      if (this.hmFullName === '') {
        this.hmFullName = this.warmLeadsTemplate.to_email
          ? this.warmLeadsTemplate.to_email
          : '';
      }
      if (
        !this.ccAddresses.length &&
        this.warmLeadsTemplate.hm_cc_emails &&
        this.warmLeadsTemplate.hm_cc_emails.length
      ) {
        this.ccAddresses = [...this.warmLeadsTemplate.hm_cc_emails];
      }
    },
  },

  mounted() {
    if (this.hmFullName === '') {
      this.hmFullName = this.warmLeadsTemplate.to_email
        ? this.warmLeadsTemplate.to_email
        : '';
    }
    if (
      !this.ccAddresses.length &&
      this.warmLeadsTemplate.hm_cc_emails &&
      this.warmLeadsTemplate.hm_cc_emails.length
    ) {
      this.ccAddresses = [...this.warmLeadsTemplate.hm_cc_emails];
    }
  },

  methods: {
    async getWarmLeadsTemplate() {
      try {
        await this.$store.dispatch(
          'projects/candidates/fetchWarmLeadsTemplate',
          {
            candidateId: this.$store.getters['user/getIsUserV2']
              ? this.candidate.core_candidate_id
              : this.candidate._id,
            projectId: this.projectId,
          }
        );
      } catch (e) {
        console.log(e);
      }
    },

    async sendMail() {
      const requestData = {
        // to_email: this.hmFullName,
        cc_email: this.ccAddresses,
        email_subject: this.warmLeadsTemplate.email_subject,
        email_body: this.isEdited
          ? this.emailBody
          : this.warmLeadsTemplate.email_body,

        project_id: this.projectId,
        email_type: 'hm_found_warm_lead',
        to_email: '',
        candidate_id: this.candidateId,
      };
      const nextTab = this.isV2 ? 'HIRING_MANAGER' : 'WARM_LEADS_HM';

      try {
        const apiUrl = `${Config.env.API_URL}email`;
        const response = await post(apiUrl, requestData);
        if (response && response.status === 200) {
          this.$emit('move');
          this.isSuccessSending = true;
          this.sendDialog = false;
          this.loading = false;
          this.setCandidateStatus(this.candidateId, nextTab);
        }
      } catch (e) {
        this.snackbar = true;
        this.loading = false;
        this.snackbarMessage = 'Sending email is failed!';
      }
    },

    async sendMailV2() {
      const params = {
        email_cc: this.ccAddresses,
        email_subject: this.warmLeadsTemplate.email_subject,
        email_body: this.isEdited
          ? this.emailBody
          : this.warmLeadsTemplate.email_body,

        project_id: this.projectId,
        email_to: this.warmLeadsTemplate.to_email,
        candidate: this.candidate,
      };
      const response = await this.$store.dispatch(
        'projects/candidates/approveCandidateRecruiter',
        params
      );
      if (response && response.status === 200) {
        this.isSuccessSending = true;
        this.sendDialog = false;
        this.loading = false;
        this.$emit('move');
      } else {
        this.snackbar = true;
        this.loading = false;
        this.snackbarMessage = 'Sending email is failed!';
      }
    },

    async onSubmit() {
      this.$refs.form1.validate();
      if (!this.formValid) return;
      // send mail
      this.loading = true;
      if (this.$store.getters['user/getIsUserV2']) {
        await this.sendMailV2();
        return;
      }
      await this.sendMail();
      // update candidate status
    },

    async setCandidateStatus(candidateId, status) {
      await this.$store.dispatch('projects/candidates/updateCandidateState', {
        projectId: this.projectId,
        tab: this.tab,
        candidateId,
        newTab: status,
      });
    },

    onChange(e) {
      this.isEdited = true;
      this.emailBody = e.target.innerHTML;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
.card-footer-btn {
  height: 43px !important;

  .card-footer-btn-text {
    font-weight: normal;
    text-transform: capitalize;
    line-height: normal;
    letter-spacing: 0.54px;
    color: $black;
  }
}
@media (max-width: 37.5rem) {
  .card-action-footer .action-button-text {
    display: none;
  }
  .card-action-footer .action-button-icon.approve,
  .card-action-footer .action-button-icon.reject {
    margin-left: 0.625rem;
    margin-right: 0.625rem;
  }
}
.send-btn {
  justify-content: center;
  padding-bottom: 30px !important;
  &::v-deep .v-btn {
    width: 100%;
    max-width: 162px;
    display: inline-block;
  }
}
.email-body-container {
  padding: 30px;
  .email-body {
    border: 1px solid $scrollbar-color;
    border-radius: 8px;
    overflow: hidden;

    &::v-deep table {
      margin: 0 auto;

      table tbody tr td {
        border: none !important;
      }
      table a {
        display: none !important;
      }
    }
  }
}
.v-dialog > .v-card > .v-card__title.email-popup-title {
  color: $black;
  font-size: 1em;
  background: $title-color;
  padding: 10px 30px;
}
.email-header {
  padding: 20px 30px;
  color: $black;
  &::v-deep td {
    padding: 5px 10px 5px 0 !important;
    height: auto !important;
    font-size: 14px;
    border-bottom: 1px solid $scrollbar-color;
    &:first-child {
      color: $gray-light;
      width: 20px;
    }
  }
}
.mail-collaborators {
  font-size: 14px;
  max-width: 400px;
  margin: 0px;
  &::v-deep .v-input__slot {
    margin: 0px;
  }
  &::v-deep .v-text-field__details {
    display: none;
  }
}
.success-popup {
  color: $success;

  font-size: 14px;
  &::v-deep .v-card__text {
    color: $success !important;
    text-align: center;
    padding-bottom: 13px !important;
  }
}

.success-title {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
}

.close-btn {
  cursor: pointer;
}
.loading-candidate {
  z-index: 99;
}
</style>
